import React, { useState } from 'react';
import {
    IconButton,
    InputAdornment,
    Dialog,
    DialogContent,
    Grid,
    Button
} from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import ReactPlayer from 'react-player'
import { DialogTitle } from '../Dialog/Dialog';

const useStyles = makeStyles((theme) => ({
    widthV1: {
        width: '90% !important',
        height: '90%'
    },
    dcV1: {
        padding: '0px !important'
    }
}));

const YoutubePlayerDialog = ({ open, onClose, urlValue, title }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='lg' classes={{ paperWidthLg: classes.widthV1 }}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="youtube-player-dialog" open={dialogOpen}
            >
                <DialogTitle id="youtube-player-dialog-title" onClose={handleClose}>
                    {title}
                </DialogTitle>
                <DialogContent className={classes.dcV1}>
                    <ReactPlayer url={urlValue} playing={true} width={'auto'} height={'100%'} controls={true} />
                </DialogContent>
            </Dialog>
        </>
    );
}

export default YoutubePlayerDialog;